<template lang="pug">
  v-card(
    color="white"
    min-width="350"
  )
    v-toolbar.px-4(
      color="primary"
      dark
      flat
    )
      v-toolbar-title Login

    v-form.px-8.pt-4.pb-9(
      ref="form"
      v-model="valid"
      lazy-validation
    )

      v-text-field(
        v-model="form.login"
        label="Имя пользователя"
        required
      )

      v-text-field(
        v-model="form.password"
        type="password"
        label="Пароль"
        required
      )

      vue-recaptcha(
      :loadRecaptchaScript="true"
      ref="recaptcha"
      size="invisible"
      :sitekey="key"
      @verify="verify"
      @expired="recaptchaReset"
      )
      .d-flex.justify-right.mt-2
        v-btn(
          :disabled="!valid"
          color="secondary"
          class="ml-auto"
          @click="login"
        ) Войти

      br
      br
      p.recaptcha-text
        |This site is protected by reCAPTCHA and the Google
        |&nbsp;
        a.color-link-active( href="https://policies.google.com/privacy" target="_blank" ) Privacy Policy
        |&nbsp;
        |and
        |&nbsp;
        a.color-link-active( href="https://policies.google.com/terms" target="_blank" ) Terms of Service
        |&nbsp;
        |apply.

</template>
<script>
import VueRecaptcha from 'vue-recaptcha'
import notify from '../mixins/notify'
import LoginGQL from '../graphql/switips/Login.gql'
import { onLogin } from '../vue-apollo'

export default {
  mixins: [notify],
  components: { VueRecaptcha },
  data() {
    return {
      key: process.env.VUE_APP_RECAPTCHA,
      valid: true,
      form: {
        login: '',
        password: '',
        captcha: ''
      }
      // emailRules: [
      //   v => !!v || 'E-mail обязателен',
      //   v => /.+@.+\..+/.test(v) || 'Неверный формат E-mail'
      // ]
    }
  },
  methods: {
    recaptchaReset() {
      this.$refs.recaptcha.reset()
    },
    login() {
      this.$refs.recaptcha.execute()
    },
    validate() {
      this.$refs.form.validate()
    },
    async verify(recaptchaToken) {
      this.form.captcha = recaptchaToken
      // this.loading = true
      try {
        const res = await this.$apollo.mutate({
          client: 'auth',
          mutation: LoginGQL,
          variables: this.form
        })
        this.notify({
          text: 'Реквизиты корректны'
        })
        await onLogin(this.$apollo.getClient(), res.data.login.access_token, res.data.login.refresh_token)

        await this.$router.push({
          name: 'banners__list'
        })
      } catch (err) {
        this.recaptchaReset()
        this.notify({
          text: err.message,
          type: 'error'
        })
        throw new Error(err)
      }
      // this.$request({
      //   query: `
      //     mutation ($login: String!, $password: String!, $captcha: String!) {
      //       login (input: { login: $login, password: $password, captcha: $captcha }) {
      //         access_token,
      //         expires_at,
      //         refresh_token
      //       }
      //     }
      //   `,
      //   variables: this.form
      // }).then((response) => {
      //   // this.saveToken(response.data.data.login)
      //   this.loading = false
      //   this.close()
      // }).catch(() => {
      //   this.recaptchaReset()
      //   this.loading = false
      // })
    }
  }
}
</script>
